import Vue from 'vue';

import appRoot from 'vue/base/app-root.js';
import initVuex from 'vue/vuex';
import initRouter from 'vue/router';
import registry from './registry';


/**
 * Bootstrap the vue root instance
 */
function init() {
    return registry().then(() => {
        // Init vuex
        initVuex(appRoot);

        // Init vue-router
        initRouter(appRoot);

        // Instantiate the vue instance
        return new Vue(appRoot);
    });
}

export default init;



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/base/index.js